export default __webpack_public_path__ + "static/media/pearl-1.fa24dbe1.png";